import { z } from "zod";

/**
 * The hosted reranking models a collection may name in `Collection.reranker`.
 * Every write door validates against this list; the search reads the stored
 * name and falls back to {@link DEFAULT_RERANKER_MODEL} when the column is
 * empty or holds a name outside this list.
 */
export const RERANKER_MODELS = [
  "cohere-rerank-4-fast",
  "bge-reranker-v2-m3",
  "pinecone-rerank-v0"
] as const;

export type RerankerModel = (typeof RERANKER_MODELS)[number];

/** The most documents each model ranks in one call; a search cuts its pool to this. */
export const RERANKER_MAX_CANDIDATES = {
  "cohere-rerank-4-fast": 250,
  "bge-reranker-v2-m3": 100,
  "pinecone-rerank-v0": 100
} as const satisfies Record<RerankerModel, number>;

/** The model a search uses when the collection names none. */
export const DEFAULT_RERANKER_MODEL: RerankerModel = "cohere-rerank-4-fast";

/**
 * `Collection.reranker` selects a model, it never switches one on: the schema
 * lists the models, so a boolean, `"true"`, an empty string or an unlisted name
 * cannot pass, and the 400 names the allowed values.
 */
export const RerankerModelSchema = z.enum(RERANKER_MODELS);

export function isRerankerModel(value: unknown): value is RerankerModel {
  return RerankerModelSchema.safeParse(value).success;
}
